module.exports = __webpack_public_path__ + "img/undraw_active_support_6rwo.502891de.svg";